import { vuex as auth } from './pages/auth'
import { vuex as plans } from './pages/plans'
import { vuex as subscribers } from './pages/customers'
import { vuex as pagination } from './components/shareds/pagination'
import { vuex as signup } from './pages/signup'
import { vuex as contracts } from './pages/contracts'
import { vuex as wizard } from './pages/wizard'
import { vuex as entries } from './pages/entries'
import { vuex as flash } from 'src/app/components/shareds/flash'
import { vuex as invoices } from './pages/invoices'
import { vuex as settings } from './pages/settings'
import { vuex as contractPlans } from './pages/contract_plans'
import { vuex as subscribe } from './pages/subscribe'
import { vuex as payments } from './pages/payments'
import { vuex as contractPlanEntries } from './pages/contract_plan_entries'
import { vuex as accessUsers } from './pages/access_users'
import { vuex as orders } from './pages/orders'
import { vuex as authorizedLink } from './components/shareds/authorized-link'
import { vuex as taxes } from './pages/taxes'

export default { auth, plans, contracts, subscribers, pagination, flash, signup, wizard, invoices, entries, contractPlans, settings, subscribe, payments, contractPlanEntries, accessUsers, orders, authorizedLink, taxes }



// WEBPACK FOOTER //
// ./src/app/vuex.js